export default "/assets/svg/factura.svg"